export const APP_CONFIG = {
    pin: "0103",
    finalMessage: "YOU BRING THIS PLACE TO LIFE.",
    soundEnabled: true,
    vibrationEnabled: true
};
